import React, { useState, useEffect } from 'react';
import { TextField, Button, Stack, Box } from '@mui/material';

const PageForm = ({ initialData, onSubmit, onCancel }) => {
  const [form, setForm] = useState({
    title: { fa: '', en: '' },
    description: ''
  });

  useEffect(() => {
    if (initialData) {
      setForm({
        title: {
          fa: initialData.title?.fa || '',
          en: initialData.title?.en || ''
        },
        description: initialData.description || ''
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'fa' || name === 'en') {
      setForm((prev) => ({
        ...prev,
        title: {
          ...prev.title,
          [name]: value
        }
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.title.fa.trim()) {
      alert('عنوان فارسی الزامی است');
      return;
    }
    onSubmit(form);
  };

  return (
    <Box component="form" onSubmit={handleSubmit} dir="rtl">
      <Stack spacing={2}>
        <TextField
          label="عنوان صفحه (فارسی)"
          name="fa"
          value={form.title.fa}
          onChange={handleChange}
          required
        />
        <TextField
          label="Page Title (English)"
          name="en"
          value={form.title.en}
          onChange={handleChange}
        />
        <TextField
          label="توضیحات"
          name="description"
          value={form.description}
          onChange={handleChange}
          multiline
          rows={3}
        />
        <Stack direction="row" justifyContent="flex-end" spacing={2}>
          <Button onClick={onCancel}>انصراف</Button>
          <Button variant="contained" type="submit">
            ذخیره
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default PageForm;
